import { connect } from 'react-redux';
import MetaInfoComponent from '../components/MetaInfoComponent';

const mapStateToProps = (state) => ({
    metaType: state.aovivoBar.NowPlaying.musicLive.metaType,
});

export default connect(mapStateToProps, {})(MetaInfoComponent);
